/**
 * Get direct login params from the URL for Japan market
 */
export default function getDirectLoginParams(
  search = window.location.search,
): string {
  const searchParams = new URLSearchParams(search);
  const pairs: string[] = [];

  searchParams.forEach((value, key) => {
    if (
      key === "market" ||
      key === "source" ||
      key === "isDirectLogin" ||
      value === ""
    )
      return;

    pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  });

  if (pairs.length === 0) return "";

  return encodeURIComponent(pairs.join("&"));
}
